import { useElementShown } from '@hh.ru/analytics-js';
import authorizeLoginProfessionButtonClick from '@hh.ru/analytics-js-events/build/career_platform/authorization/authorize_login_profession_button_click';
import authorizeLoginProfessionElementShown from '@hh.ru/analytics-js-events/build/career_platform/authorization/authorize_login_profession_element_shown';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import {
    ActionBar,
    BottomSheet,
    BottomSheetFooter,
    Button,
    Card,
    Modal,
    Text,
    Title,
    useBreakpoint,
} from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { LOGIN_ROUTE } from 'src/app/routesUtils';
import { useCalculatorContext } from 'src/pages/Profession/components/SectionCalculator/Context';

import styles from './styles.less';

const TrlKeys = {
    title: 'career-platform.profession.sections.calculator.login-for-skills.title',
    banner: 'career-platform.profession.sections.calculator.login-for-skills.banner',
    list0: 'career-platform.profession.sections.calculator.login-for-skills.list.0',
    list1: 'career-platform.profession.sections.calculator.login-for-skills.list.1',
    list2: 'career-platform.profession.sections.calculator.login-for-skills.list.2',
    list3: 'career-platform.profession.sections.calculator.login-for-skills.list.3',
    footer: {
        button: 'career-platform.profession.sections.calculator.login-for-skills.button',
        close: 'career-platform.profession.sections.calculator.login-for-skills.close',
    },
};

const CalculatorLoginDialog: TranslatedComponent = ({ trls }) => {
    const {
        professionId,
        modalLogin: { isOpen, onClose },
    } = useCalculatorContext();

    const { isMobile } = useBreakpoint();

    const ref = useElementShown(authorizeLoginProfessionElementShown, { professionId, authType: 'MODAL_CALCULATOR' });

    const handleLogin = () => {
        authorizeLoginProfessionButtonClick({
            professionId,
            authType: 'MODAL_CALCULATOR',
        });
    };

    const Content = (
        <div ref={ref} className={styles.content}>
            {isMobile && (
                <Title size="medium" Element="h3">
                    {trls[TrlKeys.title]}
                </Title>
            )}
            <Card padding={16} borderRadius={16} style="neutral" stretched>
                <Text typography="paragraph-2-regular" Element="p">
                    {trls[TrlKeys.banner]}
                </Text>
            </Card>
            <ul className={styles.list}>
                <li>
                    <Text typography={isMobile ? 'paragraph-2-regular' : 'paragraph-1-regular'} Element="span">
                        {trls[TrlKeys.list0]}
                    </Text>
                </li>
                <li>
                    <Text typography={isMobile ? 'paragraph-2-regular' : 'paragraph-1-regular'} Element="span">
                        {trls[TrlKeys.list1]}
                    </Text>
                </li>
                <li>
                    <Text typography={isMobile ? 'paragraph-2-regular' : 'paragraph-1-regular'} Element="span">
                        {trls[TrlKeys.list2]}
                    </Text>
                </li>
                <li>
                    <Text typography={isMobile ? 'paragraph-2-regular' : 'paragraph-1-regular'} Element="span">
                        {trls[TrlKeys.list3]}
                    </Text>
                </li>
            </ul>
        </div>
    );

    const CloseButton = (
        <Button
            mode={isMobile ? 'secondary' : 'tertiary'}
            onClick={onClose}
            stretched={isMobile}
            size={isMobile ? 'large' : 'medium'}
        >
            {trls[TrlKeys.footer.close]}
        </Button>
    );

    const LoginButton = (
        <Button
            Element={SPALink}
            to={LOGIN_ROUTE}
            isSeoLink
            onClick={handleLogin}
            mode="primary"
            stretched={isMobile}
            size={isMobile ? 'large' : 'medium'}
        >
            {trls[TrlKeys.footer.button]}
        </Button>
    );

    if (isMobile) {
        return (
            <BottomSheet
                visible={isOpen}
                onClose={onClose}
                footer={
                    <BottomSheetFooter>
                        {LoginButton}
                        {CloseButton}
                    </BottomSheetFooter>
                }
            >
                {Content}
            </BottomSheet>
        );
    }

    return (
        <Modal
            visible={isOpen}
            onClose={onClose}
            title={trls[TrlKeys.title]}
            footer={<ActionBar secondaryActions={CloseButton} primaryActions={LoginButton} />}
        >
            {Content}
        </Modal>
    );
};

export default translation(CalculatorLoginDialog);
